"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
const Tabs_module_css_1 = __importDefault(require("./Tabs.module.css"));
/**
 *
 */
function Tabs({ tabs, idPrefix, initActiveTab, highlightActiveTab = false, scrollToTopOnChange = false, }) {
    const [activeTabIndex, setActiveTabIndex] = (0, react_1.useState)(initActiveTab ?? 0);
    (0, react_1.useEffect)(() => {
        scrollToTopOnChange && window.scrollTo({ top: 0, behavior: "smooth" });
    }, [activeTabIndex, scrollToTopOnChange]);
    (0, react_1.useEffect)(() => {
        if (initActiveTab || initActiveTab === 0) {
            setActiveTabIndex(initActiveTab);
        }
    }, [initActiveTab]);
    const getSelectedIndicatorStyle = () => ({
        transition: "all 0.3s ease-in-out",
        width: "100%",
        // supports RTL
        marginInlineStart: `${activeTabIndex * 100}%`,
    });
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("nav", { className: Tabs_module_css_1.default.nav, children: (0, jsx_runtime_1.jsx)("div", { role: "tablist", className: Tabs_module_css_1.default.triggers, children: tabs.map((tab, i) => {
                        const tabLink = tab;
                        return ((0, jsx_runtime_1.jsxs)("div", { role: "tab", "aria-selected": activeTabIndex === i, className: (0, clsx_1.default)(Tabs_module_css_1.default.tabTrigger, {
                                [Tabs_module_css_1.default.tabTriggerActive]: activeTabIndex === i,
                                [Tabs_module_css_1.default.tabTriggerHighlight]: activeTabIndex === i && highlightActiveTab,
                            }), id: `tab-trigger-${i}`, "data-testid": `tab-trigger-${i}`, onClick: () => setActiveTabIndex(i), children: [tabLink.href ? ((0, jsx_runtime_1.jsx)("a", { href: tabLink.href, onClick: tabLink.onClick, children: tabLink.label })) : ((0, jsx_runtime_1.jsx)("button", { type: "button", children: tab.label })), i === 0 && ((0, jsx_runtime_1.jsx)("hr", { style: getSelectedIndicatorStyle(), "data-testid": "active-indicator", className: Tabs_module_css_1.default.selectedIndicator }))] }, `${idPrefix}-tab-trigger-${i}`));
                    }) }) }), (0, jsx_runtime_1.jsx)("div", { children: tabs.map((tab, i) => ((0, jsx_runtime_1.jsx)("div", { role: "tabpanel", "aria-labelledby": `${idPrefix}-tab-trigger-${i}`, hidden: activeTabIndex !== i, children: tab.content() }, `${idPrefix}-tab-panel-${i}`))) })] }));
}
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map